import { render, staticRenderFns } from "./PaySuccess.vue?vue&type=template&id=67ed70d4&scoped=true&"
import script from "./PaySuccess.vue?vue&type=script&lang=js&"
export * from "./PaySuccess.vue?vue&type=script&lang=js&"
import style0 from "./PaySuccess.vue?vue&type=style&index=0&id=67ed70d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed70d4",
  null
  
)

export default component.exports